import { getRoot } from "./utils.js";
const themeProvider = (root, initialTheme) => {
  let themeClass = `dsf-theme-${initialTheme}`;
  const themeRoot = getRoot(root);
  if (!themeRoot) {
    throw new Error(`[DSF] Could not find theme provider root: ${root}`);
  }
  themeRoot.classList.add(themeClass);
  return (newTheme) => {
    themeRoot.classList.remove(themeClass);
    themeRoot.classList.add(`dsf-theme-${newTheme}`);
    themeClass = `dsf-theme-${newTheme}`;
  };
};
export {
  themeProvider
};
